import type { CustomerPortalRpcClient } from "@redotech/customer-portal-sdk/rpc/client";
import { Context, createContext } from "react";

/**
 * Provides an authenticated RPC client to the app.
 * Will be undefined until the user is authenticated.
 */
export const RpcClientContext: Context<CustomerPortalRpcClient | undefined> =
  createContext<CustomerPortalRpcClient | undefined>(undefined);
